import { getAxiosErrorMessage } from '~/helpers/axios-error'

export default (context, inject) => {
  const toast = {
    error: ({ message, error }) => {
      let errorMessage = message || '予期せぬエラーが発生しました'
      // messageが指定されていない場合、axiosのエラーを確認
      if (!message) {
        const axiosErrorMessage = getAxiosErrorMessage(error)
        if (axiosErrorMessage) {
          errorMessage = axiosErrorMessage
        }
      }
      context.store.dispatch('showErrorToast', {
        message: errorMessage
      })
    },
    success: (message) => {
      context.store.dispatch('showSuccessToast', {
        message
      })
    }
  }

  context.$toast = toast
  inject('toast', toast)
}
